export default "__VITE_ASSET__BJDEvgqi__"